import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  isHiding: boolean
  cycleLabel: string
  cycleCurrency: string
  onConfirm: () => void
  onClose: () => void
}

const HideCycleConfirmationModal = ({
  isHiding,
  cycleLabel,
  cycleCurrency,
  onConfirm,
  onClose,
}: Props) => {
  const title = isHiding
    ? i18n.t('compensations.settings.cycles.hide_modal.title', {
        cycle: cycleLabel,
        currency: cycleCurrency,
      })
    : i18n.t('compensations.settings.cycles.unhide_modal.title', {
        cycle: cycleLabel,
        currency: cycleCurrency,
      })

  const modalContent = isHiding
    ? {
        description: i18n.t('compensations.settings.cycles.hide_modal.main_description'),
        bullets: [
          i18n.t('compensations.settings.cycles.hide_modal.bullet_1'),
          i18n.t('compensations.settings.cycles.hide_modal.bullet_2'),
          i18n.t('compensations.settings.cycles.hide_modal.bullet_3'),
        ],
      }
    : {
        description: i18n.t('compensations.settings.cycles.unhide_modal.description'),
        bullets: [
          i18n.t('compensations.settings.cycles.unhide_modal.bullet_1'),
          i18n.t('compensations.settings.cycles.unhide_modal.bullet_2'),
        ],
      }

  return (
    <F0Dialog
      isOpen
      title={title}
      onClose={onClose}
      primaryAction={{
        label: i18n.t('common.confirm'),
        onClick: () => {
          onConfirm()
          onClose()
        },
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <Box flexDirection="column" gap="s16">
        <Text.Normal color="grey1000">{modalContent.description}</Text.Normal>
        {/* eslint-disable-next-line factorial/no-raw-html */}
        <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
          {modalContent.bullets.map((bullet, index) => (
            // eslint-disable-next-line factorial/no-raw-html
            <li key={index} style={{ marginBottom: '4px' }}>
              <Text.Normal color="grey1000">{bullet}</Text.Normal>
            </li>
          ))}
        </ul>
      </Box>
    </F0Dialog>
  )
}

export default HideCycleConfirmationModal
